import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Loans from "@/pages/Loans";
import LoanDetail from "@/pages/LoanDetail";
import Calculators from "@/pages/Calculators";
import EmiPage from "@/pages/EmiPage";
import EligibilityPage from "@/pages/EligibilityPage";
import Compare from "@/pages/Compare";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import LeadDetail from "@/pages/admin/LeadDetail";
import Employees from "@/pages/admin/Employees";
import Partners from "@/pages/admin/Partners";
import Products from "@/pages/admin/Products";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import FaqsAdmin from "@/pages/admin/FaqsAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import Callbacks from "@/pages/admin/Callbacks";
import Sheets from "@/pages/admin/Sheets";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/loans" element={<Loans />} />
                <Route path="/loans/:slug" element={<LoanDetail />} />
                <Route path="/calculators" element={<Calculators />} />
                <Route path="/calculators/emi" element={<EmiPage />} />
                <Route path="/calculators/eligibility" element={<EligibilityPage />} />
                <Route path="/eligibility" element={<EligibilityPage />} />
                <Route path="/compare-loans" element={<Compare />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/apply" element={<Apply />} />
                <Route path="/privacy-policy" element={<Legal type="privacy" />} />
                <Route path="/terms" element={<Legal type="terms" />} />
                <Route path="/disclaimer" element={<Legal type="disclaimer" />} />
                <Route path="/cookie-policy" element={<Legal type="cookie" />} />
                <Route path="/consent-policy" element={<Legal type="consent" />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="leads" element={<Leads />} />
                <Route path="leads/:id" element={<LeadDetail />} />
                <Route path="employees" element={<Employees />} />
                <Route path="lenders" element={<Partners />} />
                <Route path="products" element={<Products />} />
                <Route path="blog" element={<BlogAdmin />} />
                <Route path="faqs" element={<FaqsAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="callbacks" element={<Callbacks />} />
                <Route path="sheets" element={<Sheets />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
            <Toaster position="top-right" richColors />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
